import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import fullStack from "../assets/images/fullstack.svg";
import jamStack from "../assets/images/cloud_infrastructure.svg";

const WhatIDo = () => {
  return (
    <>
      <div className='what-i-do-section'>
        <Container fluid>
          <h1>What I Do?</h1>
          <Row>
            <Col lg='7' className='place order-1 order-lg-1'>
              <div className='right-content'>
                <h3>Full Stack Development</h3>
                <ul>
                  <li>
                    <span>⚡</span>
                    <p>Building resposive website front end using React app.</p>
                  </li>
                  <li>
                    <span>⚡</span>
                    <p>Creating application backend in Node, Express & MongoDB.</p>
                  </li>
                  <li>
                    <span>⚡</span>
                    <p>Building Full stack web app using MERN stack technology.</p>
                  </li>
                </ul>

                {/* <div className='btn-section'>
      <Link to={profileData.CTA_link} className='mk-btn'>
        {profileData.CTA_label}
      </Link>
    </div> */}
              </div>
            </Col>
            <Col lg='5' className='p-0 order-2 order-lg-2'>
              <div className='left-content lft-img'>
                <img src={fullStack} alt='myimage' />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className='jam-section'>
        <Container fluid>
          <Row>
            <Col lg='5' className='p-0 order-2 order-lg-1'>
              <div className='left-content lft-img'>
                <img src={jamStack} alt='myimage' />
              </div>
            </Col>
            <Col lg='7' className='place order-1 order-lg-2'>
              <div className='right-content'>
                <h3>Jam Stack Development</h3>
                <ul>
                  <li>
                    <span>⚡</span>
                    <p>
                      Building resposive website front end using React app and
                      Gatsby js.
                    </p>
                  </li>
                  <li>
                    <span>⚡</span>
                    <p>
                      Creating application backend in Strapi and PostgreSQL.
                    </p>
                  </li>
                  <li>
                    <span>⚡</span> <p>Deploying Strapi CMS on Heroku.</p>
                  </li>
                </ul>

                {/* <div className='btn-section'>
      <Link to={profileData.CTA_link} className='mk-btn'>
        {profileData.CTA_label}
      </Link>
    </div> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default WhatIDo;
